'use strict';

jQuery(document).ready(function($) {

    //Your Code

});


// WEBPACK FOOTER //
// ./resources/scripts/parts/header-menu.js